import Close from '@streamlinehq/streamlinehq/img/streamline-light/interface-essential/form-validation/close.svg';
import NavigationMenu from '@streamlinehq/streamlinehq/img/streamline-light/interface-essential/menu/navigation-menu.svg';
import { E2eTestElementId } from '@upright/test-ids/dom-elements';
import { useGetLoggedInUser } from '@upright/ui/common/generic/hooks';
import { useEffect, useState } from 'react';
import { slide as MenuSlide } from 'react-burger-menu';
import { useLocation } from 'react-router';
import styled from 'styled-components';
import { fluidSpaceLg } from '../../../../utilities/fluid/fluid';
import { BouSvgIcon } from '../../../bou-svg-icon';
import { BurgerIconWrap, ContentMain, ContentRoot, ExternalLink, MenuRoot, Section } from '../shared-menus';
import { AccountBlock } from './account-block';
import { AskAiBlock } from './ask-ai-block';
import { DataBlock } from './data-block';
import { LearnMoreBlock } from './learn-more-block';
import { LoggedInBlock } from './logged-in-block';
import { UseCasesBlock } from './use-cases-block';
import { ToolsBlock } from './tools-block';

export function BurgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const openMenu = () => {
    setIsOpen(true);
  };

  const location = useLocation();
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const user = useGetLoggedInUser();

  return (
    <MenuRoot data-testid={E2eTestElementId.MOBILE_BURGER}>
      <MenuSlide
        width={'100%'}
        customBurgerIcon={
          <IconWrap onClick={openMenu}>
            <BouSvgIcon icon={<NavigationMenu />} />
          </IconWrap>
        }
        isOpen={isOpen}
        onStateChange={(state: { isOpen: boolean | ((prevState: boolean) => boolean) }) => {
          setIsOpen(state.isOpen);
        }}
        right
        noOverlay={true}
      >
        <ContentRoot>
          <ContentMain>
            {user && (
              <Section>
                <LoggedInBlock />
              </Section>
            )}
            <AskAiBlock />
            <Section>
              <UseCasesBlock />
            </Section>

            <Section>
              <DataBlock />
            </Section>
            <Section>
              <ToolsBlock />
            </Section>
            <Section>
              <LearnMoreBlock />
            </Section>
            <Section>
              <AccountBlock />
            </Section>
            <Section>
              <NewToUpright>
                New to Upright? Visit our{' '}
                <ExternalLink href="https://www.uprightproject.com" target="_blank">
                  main website
                </ExternalLink>
              </NewToUpright>
            </Section>
          </ContentMain>
          <CloseButtonWrap id={E2eTestElementId.MOBILE_BURGER_CLOSE}>
            <BouSvgIcon icon={<Close />} />
          </CloseButtonWrap>
        </ContentRoot>
      </MenuSlide>
    </MenuRoot>
  );
}

const CloseButtonWrap = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

const NewToUpright = styled.div`
  font-size: 14px;
`;

const IconWrap = styled(BurgerIconWrap)`
  ${fluidSpaceLg('font-size', 80)}
`;
